<template>
  <div>
    <transition name="ol-loading">
      <div v-if="value">
        <div class="ol-loading">
          <img src="https://img.kandagar.com/images/1/wheel-forever.gif" alt="" class="ol-loading__image">
          <div class="ol-loading__text">{{text}}</div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
	export default {
		name: "ol-loading",
    props: {
			value: {
				type: Boolean,
        default: false
      },
      text: {
				type: String,
        default: 'Пожалуйста, подождите'
      }
    }
	}
</script>

<style scoped lang="scss">
  .ol-loading {
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    flex-flow: column wrap;

    &__image {
      display: block;
      position: relative;
      width: 50px;
      height: 50px;
    }

    &__text {
      display: block;
      position: relative;
      font-size: 0.9em;
      font-weight: bold;
      margin-top: 9px;
    }


    &-enter {
      opacity: 0;
    }

    &-leave-active {
      opacity: 0;
    }

    &-enter,
    &-leave-active {
      &-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/Components/Loading.vue